import { Box, Flex } from "@chakra-ui/react";
import { useRef } from "react";

import { Pagination, PaginationProps, Table, TableProps } from "@nens/chakra/components";
import { useRect } from "@nens/react/hooks";

const lineHeight = 29;

interface TableOverviewProps<T> extends TableProps<T> {
  paginationProps: PaginationProps | undefined;
}
const TableOverview = <T extends { uuid?: string }>({
  height = "100%",
  width = "full",
  tableData,
  paginationProps,
  ...props
}: TableOverviewProps<T>) => {
  const ref = useRef<HTMLDivElement>(null);
  const rect = useRect(ref);

  return (
    <Box w={width} flexGrow={1} h="full" overflow="hidden">
      <Flex h={`calc(${height} - ${rect?.height || 0}px)`} w={width} overflow="hidden">
        <Table<T & { uuid: string }>
          emptyText="Er is geen data (met de gekozen filters)"
          height={`calc(${height} - 40px)`}
          w="full"
          lineHeight={lineHeight + "px"}
          themeColor="accent"
          borderColor="accentLight"
          buttonVariant="outlinePrimarySmall"
          {...props}
          accordionButtonProps={{
            _hover: { bg: "accentLight" },
          }}
          tableRowGridProps={{ borderBottomWidth: "1px", borderBottomColor: "accentLight" }}
          columnDefinitions={props.columnDefinitions.map(({ title, ...rest }) => ({
            ...rest,
            titleRenderFunction: () => <Box as="strong">{title}</Box>,
          }))}
          tableData={tableData as (T & { uuid: string })[]}
        />
      </Flex>
      {paginationProps?.numPages && (
        <Flex
          ref={ref}
          w="full"
          justifyContent="flex-end"
          pos="relative"
          bg="white"
          borderX="1px solid"
          borderBottom="1px solid"
          borderColor="accentLight"
          boxShadow="0 -1px 5px rgba(0, 0, 0, 0.2)"
        >
          <Box w="full" pos="absolute" top="-1px" bg="white" height="1px" />
          <Pagination
            {...paginationProps}
            itemsPerPageChoices={[20, 40, 60, 80, 100]}
            variant="outlinePrimary"
            m="3"
            my="2"
          ></Pagination>
        </Flex>
      )}
    </Box>
  );
};

export { TableOverview };
